// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileExclamationFilledSvg from "@ant-design/icons-svg/es/asn/FileExclamationFilled";
import AntdIcon from '../components/AntdIcon';

var FileExclamationFilled = function FileExclamationFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileExclamationFilledSvg
  }));
};

FileExclamationFilled.displayName = 'FileExclamationFilled';
export default React.forwardRef(FileExclamationFilled);